import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDatepickerInputEvent, MatDialog, MatPaginator, PageEvent } from '@angular/material';
import * as moment from 'moment';
import { AppService } from 'src/_services/app.service';
import { AuthenticationService } from 'src/_services/authentication.service';
import { VoidBetsModalComponent } from '../bets-settlements/bets-settlements.component';
import { BetRollbackModal } from '../sr-bets-settlement/sr-bets-settlement.component';
import { SapRoles } from 'src/_constants/roleType';
import { Router } from '@angular/router';

@Component({
  selector: 'app-op-bets-settle',
  templateUrl: './op-bets-settle.component.html',
  styleUrls: ['./op-bets-settle.component.scss']
})
export class OpBetsSettleComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  page = 1;
  pageSize = 25;
  orgPageSize = 25;
  selectedBetId = "";
  selectedEventId = "";
  selectedMarketId = "";
  selectedCompetitionId = "";
  length: any = 0;
  sapRoles = SapRoles;
  displayTableColumns = [
    "Date",
    "UserName",
    "Bet Id",
    "MarketName",
    "Status",
    // "Select Runner",
    "Actions",
  ];
  bets = [];
  markets = [];
  sports = [];
  betStatusList = [
    { id: "", name:"All Status" },
    { id: "OPEN", name: "Open" },
    { id: "SETTLED", name: "Settled" },
    { id: "VOIDED", name: "Voided" },
  ];

  ProviderId = new FormControl([]);
  selectedSport = new FormControl([]);
  OperatorId = new FormControl([]);
  operatorData = [];
  userRole: any = JSON.parse(sessionStorage.getItem("currentUser"));
  providers: any = JSON.parse(sessionStorage.getItem("category"));
  pageEvent: any = { pageIndex: 1, pageSize: 0, length: 0 };
  selectedBetStatus = new FormControl([this.betStatusList[1]]);
  dropdownSettings: any = {};
  operatorSettings: any = {};
  sportSettings: any = {};
  statusSettings: any = {};
  showAlert: any = false;
  selected: any = {
    startDate: moment().startOf("day"),
    endDate: moment(),
  };
  startOfDay = moment().subtract(1, "days").startOf("day");
  endOfDay = moment().subtract(1, "days").endOf("day");
  ranges: any = {
    Today: [moment().startOf("day"), moment()],
    Yesterday: [
      moment(this.startOfDay),

      moment(this.endOfDay),
    ],
    "Last 7 Days": [
      moment(moment().subtract(6, "days").startOf("day")),
      moment(),
    ],
    "Last 30 Days": [
      moment(moment().subtract(29, "days").startOf("day")),
      moment(),
    ],
    "This Month": [moment().startOf("month"), moment()],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
  };
  competitionidfilter: boolean = false;
  transactionfilter: boolean = false;
  eventidfilter: boolean = false;
  marketidfilter: boolean = false;
  transactionfill() {
    this.transactionfilter = true;
  }
  competitionidfill() {
    this.competitionidfilter = true;
  }

  eventidfill() {
    this.eventidfilter = true;
  }

  marketidfill() {
    this.marketidfilter = true;
  }

  constructor(
    private appService: AppService,
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: true,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.operatorSettings = {
      singleSelection: false,
      idField: "item_id",
      textField: "item_text",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.sportSettings = {
      singleSelection: true,
      idField: "SportId",
      textField: "SportName",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.statusSettings = {
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.getOperatorData();
    this.onSelectedProvider(this.providers[0]);
  }

  getBetList() {
    let filters;
    try {
      if (this.selectedBetId == "" || this.selectedBetId == null) {
        filters = {
          startTime:
          this.selected.startDate !== null
            ? Math.floor(new Date(this.selected.startDate).getTime() / 1000)
            : 0,
        endTime:
          this.selected.endDate !== null
            ? Math.floor(new Date(this.selected.endDate).getTime() / 1000)
            : 0,
          providerId: this.ProviderId.value[0],
          operatorId: this.OperatorId.value.length === 0 ? null : this.OperatorId.value,
          sportIds: this.selectedSport.value[0].SportId === 'All'
          ? this.sports.filter(sport => sport.SportId !== 'All')
              .map(sport => sport.SportId)
          : [this.selectedSport.value[0].SportId],
          eventId: this.selectedEventId.toLowerCase(),
          marketId: this.selectedMarketId.toLowerCase(),
          competitionId: this.selectedCompetitionId.toLowerCase(),
          transactionId: this.selectedBetId.toLowerCase(),
          page: this.page,
          status: this.selectedBetStatus.value.length === 0 ? "" : this.selectedBetStatus.value[0].id,
          pageSize: this.orgPageSize,
        }
      } else {
        filters = {
          transactionId: this.selectedBetId.toLowerCase(),
        }
      }
     
      this.appService
        .getOPBets(filters)
        .subscribe((response) => {
          if (response.status === "RS_OK") {
            this.bets = [];
            if (this.page == 1) {
              this.length = response.totalCount;
            }
            let respbets = [];
            response.bets.forEach((bet) => {
              respbets.push({
                ...bet,
                isDisabled: true,
                selectedRunner: "",
                sessionOutcome: "",
              })
            })
            this.bets = respbets;
            
          }
        });
    } catch (err) {
      console.log(err);
    }
  }

  onDateChangeHandler = (event: MatDatepickerInputEvent<Date>) => {
    this.selected = event;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      }
    this.page = 1;
    if (this.selected.endDate) {
      let start = this.selected.startDate;
      let end = this.selected.endDate;
      let diff = end.diff(start, "days") + 1;
      if (diff > 7) {
        this.showAlert = true;
        this.selected.startDate = moment(new Date().setHours(0, 0, 0, 0));
        this.selected.endDate = moment(new Date().setHours(23, 59, 59));
        setTimeout(() => {
          this.showAlert = false;
        }, 5000);
      }
    }
  };

  getSportsByProvider(providerId) {
    try {
      this.appService.getSportForBetList(providerId).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.sports = res.sports;
          this.sports.unshift({ SportId: "All", SportName: "All Sports" });
          const cricketIndex = this.sports.findIndex(sport => sport.SportName.toLowerCase() === 'cricket');
          this.selectedSport.setValue([this.sports[cricketIndex]]);
          this.onFilterChange();
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorData = res.operators
            .sort((a, b) => {
              let fa = a.operator_id.toLowerCase(),
                fb = b.operator_id.toLowerCase();

              if (fa < fb) {
                return -1;
              }
              if (fa > fb) {
                return 1;
              }
              return 0;
            })
            .map((operator) => {
              return operator.operator_id;
            });
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }

  onSelectedProvider = (pid) => {
    if (pid == "Exchange") {
      this.getSportsByProvider("BetFair");
    } else {
      this.getSportsByProvider("SportRadar");
    }
    this.page = 1;
    this.ProviderId.setValue([pid]);
    if (this.paginator) {
    this.paginator.pageIndex = 0;
    }
  };

  getSelectedRunner(element) {
    if (element.result.RunnerId !== '') {
      return element.runners.find(runner => runner.RunnerId === element.result.RunnerId) || '';
    } else {
      return '';
    }
  }

  onFilterChange() {
    this.page = 1;
    if (this.paginator) {
      this.paginator.pageIndex = 0;
      }
    this.getBetList();
  }

  onBetIdSelection(value) {
    this.selectedBetId = value.trim();
  }

  onBetIdSelectionClear() {
    if (this.selectedBetId == "" || this.selectedBetId == null) {
      this.transactionfilter = false;
    }
    this.selectedBetId = "";
  }

  onEventIdSelection(value) {
    this.selectedEventId = value.trim();
  }

  onEventIdSelectionClear() {
    if (this.selectedEventId == "" || this.selectedEventId == null) {
      this.eventidfilter = false;
    }
    this.selectedEventId = "";
  }

  onMarketIdSelection(value) {
    this.selectedMarketId = value.trim();
  }

  onMarketIdSelectionClear() {
    if (this.selectedMarketId == "" || this.selectedMarketId == null) {
      this.marketidfilter = false;
    }
    this.selectedMarketId = "";
  }

  onCompetitionIdSelection(value) {
    this.selectedCompetitionId = value.trim();
  }

  onCompetitionIdSelectionClear() {
    if (this.selectedCompetitionId == "" || this.selectedCompetitionId == null) {
      this.competitionidfilter = false;
    }
    this.selectedCompetitionId = "";
  }


  convertDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }

  changePagination(event: PageEvent) {
    this.pageEvent = event;
    this.page = event.pageIndex + 1;
    this.pageSize = this.length;
    this.orgPageSize = event.pageSize;
    this.getBetList();
  }

  // setBetToSettle(data, index) {
  //   let value = this.bets[index];
  //   try {
  //     let filters = {
  //       betId: value.transactionId,
  //       runnerId: value.selectedRunnerId,
  //       runnerName: value.selectedRunner,
  //       sessionOutcome: isNaN(value.sessionOutcome) ? 0 : Number(value.sessionOutcome),
  //       status: "OPEN",
  //     }
  //     this.appService
  //       .betSettle(filters)
  //       .subscribe((res) => {
  //         if (res.status === "RS_OK") {
  //           this.authenticationService.openSnackBar(res.errorDescription);
  //         } else {
  //           this.authenticationService.openErrorSnackBar(res.errorDescription);
  //         }
  //         this.getBetList();
  //       });
  //   } catch (err) {
  //     console.log(err);
  //     this.authenticationService.openErrorSnackBar(err);
  //   }
  // }

  setBetToOpen(value) {
    try {
      let dialogRef = this.dialog.open(BetRollbackModal, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          betId: value,        
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.getBetList();
        }
      });
    } catch (err) {
      console.log(err);
      this.authenticationService.openErrorSnackBar("invalid");
    }
  }

  setBetToVoid(value) {
    try {
      let dialogRef = this.dialog.open(VoidBetsModalComponent, {
        backdropClass: "backdropBackground",
        hasBackdrop: true,
        data: {
          transactionId: value,
          level : "operator",
          status: "OPEN",
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.getBetList();
        }
      });
    } catch (err) {
      console.log(err);
      this.authenticationService.openErrorSnackBar("invalid");
    }

  }

  // onSelectingRunner(runnerName, index) {
  //   const responseRunner = this.bets[index].runners.find(runner => runner.RunnerName === runnerName);
  //   this.bets[index] = {
  //     ...this.bets[index],
  //     isDisabled: false,
  //     selectedRunnerId: responseRunner.RunnerId,
  //     selectedRunner: responseRunner.RunnerName,
  //   };
  // }

  convertopenDate(date) {
    return moment(date).format("DD MMM YYYY hh:mm:ss A");
  }

}
